import { render, staticRenderFns } from "./order-detail.vue?vue&type=template&id=762cab24&scoped=true"
import script from "./order-detail.vue?vue&type=script&lang=ts"
export * from "./order-detail.vue?vue&type=script&lang=ts"
import style0 from "./order-detail.vue?vue&type=style&index=0&id=762cab24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762cab24",
  null
  
)

export default component.exports